import { render, staticRenderFns } from "./OpinionAliasEdit.vue?vue&type=template&id=bb58ec8a&scoped=true"
import script from "./OpinionAliasEdit.vue?vue&type=script&lang=js"
export * from "./OpinionAliasEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb58ec8a",
  null
  
)

export default component.exports